import GroupEntity from '../entities/Group';

export type State = GroupEntity[];

const initialState: State = [];

const Group = (state: State = initialState, action: any) => {
  switch (action.type) {
    case 'SUCCESS_READ_GROUPS_ALL':
      return Array.from(new Set([...action.groups]));

    case 'SUCCESS_READ_GROUPS_RELATED':
      return Array.from(new Set([...action.groups]));

    case 'SUCCESS_READ_GROUPS_DIFF':
      return Array.from(new Set([...state, ...action.groups]));

    case 'SUCCESS_CREATE_GROUP':
      return [...state, action.group];

    case 'SUCCESS_UPDATE_GROUP':
      return state.map(group => {
        return group.id === action.group.id ? action.group : group;
      });

    case 'SUCCESS_DESTROY_GROUP':
      return state.filter(group => group.id !== action.group.id);
  }

  return state;
};

export default Group;



// WEBPACK FOOTER //
// ./src/reducers/Group.ts